<template>
  <div class="filter-row">
    <div
      v-for="(option, index) in options"
      :key="index"
      class="filter-item"
      :class="{ 'is-active': option.value === modelValue }"
      @click="$emit('update:modelValue', option.value)"
    >
      <div>
        {{ $t(option.label) }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["modelValue"],
  data: () => ({
    options: [
      { value: null, label: "all_ceremonies" },
      { value: 1, label: "ceremony_1" },
      { value: 2, label: "ceremony_2" },
      { value: 3, label: "ceremony_3" },
      { value: 4, label: "ceremony_4" },
    ],
  }),
};
</script>

<style lang="scss">
.filter-row {
  display: none;

  @media (min-width: 1250px) {
    display: flex;
  }
}

.filter-item {
  padding: 10px 30px;
  border-right: 2px solid #000;
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  &:first-child {
    border-left: 2px solid #000;
  }

  &.is-active {
    background: #6d00cf !important;
    color: #fff;
  }

  &:hover {
    background: #00a0a4;
    color: #fff;
  }
}
</style>
